function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeCircleHedgerowAndAgroforestry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1145 25.064V18.7979L14.3242 17.0076",
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.61129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9047 17.9018L16.1144 19.6922M20.5902 12.5309V13.247C21.6308 13.8443 22.4415 14.7728 22.8929 15.8845C23.3444 16.9962 23.4105 18.227 23.0809 19.3807C22.7513 20.5344 22.0448 21.5445 21.0742 22.2499C20.1036 22.9553 18.9248 23.3154 17.7257 23.2728H14.3241C13.0968 23.1895 11.9274 22.7193 10.984 21.9298C10.0407 21.1404 9.37174 20.0722 9.07339 18.8788C8.77503 17.6854 8.86259 16.4281 9.32348 15.2876C9.78437 14.1471 10.5949 13.1819 11.6386 12.5309C11.6386 11.3438 12.1102 10.2054 12.9495 9.36599C13.7889 8.52661 14.9273 8.05505 16.1144 8.05505C17.3015 8.05505 18.4399 8.52661 19.2793 9.36599C20.1187 10.2054 20.5902 11.3438 20.5902 12.5309Z",
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.61129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleHedgerowAndAgroforestry);
export default __webpack_public_path__ + "static/media/project-type-circle-hedgerow-and-agroforestry.15c96bbeb6600561661d930f65792eca.svg";
export { ForwardRef as ReactComponent };